const state = {
  api_key: null,
  client_key: null,
  master_key: null,
  register_token: null,
  login: null,
  password: null,
  is_authenticated: false,

  // system identifiers
  app_id: null,
  tenant_id: null,
  developer_id: null,
  group_id: null,
  reseller_id: null,
  merchant_id: null,
  mid_id: null,
  settings_id: null,
  session_id: null,

  // settings
  cart_settings_id: false,
  recurring_settings_id: false,
  contract_settings_id: false,
  donation_settings_id: false,
  email_settings_id: false,
  form_settings_id: false,
  installment_settings_id: false,
  invoice_settings_id: false,
  message_settings_id: false,
  notification_settings_id: false,
  order_settings_id: false,
  phone_settings_id: false,
  product_settings_id: false,
  receipt_settings_id: false,
  shipping_settings_id: false,
  subscription_settings_id: false,
  fee_settings_id: false,
  discount_settings_id: false,
  tax_settings_id: false,
  transaction_settings_id: false,
  user_settings_id: false,

  // addresses
  address_id: null,
  address_user_id: null,
  address_company_id: null,
  address_contact_id: null,
  address_mid_id: null,

  // base
  theme_id: null,

  // components
  object_id: null,

  // cart


  // customer
  customer_id: null,
  contact_id: null,
  contact_settings_id: null,
  company_id: null,
  company_settings_id: null,

  // donations

  // email
  email_id: null,
  email_template_id: null,

  // forms
  form_id: null,
  form_template_id: null,
  form_invoice_template_id: null,
  form_modal_template_id: null,
  form_redirect_template_id: null,
  form_receipt_template_id: null,
  form_redirect_settings_id: null,

  // invoice
  invoice_id: null,
  invoice_template_id: null,

  // installments:

  // links
  link_id: null,

  // notification
  notification_template_id: null,
  notification_id: null,

  // product
  product_id: null,
  cart_id: null,
  tax_id: null,
  cost_id: null,
  discount_id: null,
  fee_id: null,

  // receipts

  // recurring
  recurring_template_id: null,
  recurring_note_id: null,

  // schedule
  schedule_settings_id: null,
  schedule_id: null,

  // shipping
  shipping_id: null,

  // subscriptions

  // transactions

  // vault
  vault_banks_id: null,
  vault_card_id: null,
  vault_token_id: null,

  //user
};

const getters = {};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
